export default __webpack_public_path__ + "static/media/white_ticket.7253d222.svg";